import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { StyledPage } from './style';
import useScroll from '../../../../utils/useScroll';

interface PageLayoutProps {
  children?: React.ReactNode;
}

const PageLayout = ({ children }: PageLayoutProps) => {
  const location = useLocation();
  const { scrollToTop } = useScroll();

  useEffect(() => {
    scrollToTop();
  }, [location.pathname]); // Scroll to top on route change

  return <StyledPage className={'page-layout'}>{children}</StyledPage>;
};

export default PageLayout;
